export default {
    discoloration: "Water discoloration",
    highphyto: "High phyto concentration",
    toxins: "Seafood toxins",
    massmortalities: "Mass mortalities",
    foam: "Foam/mucilage in the coast"
}